export const INSTAGRAM = { handle: "@Lunelleappp", url: "https://www.instagram.com/Lunelleappp/" };

export const SHARE_KIT = [
  {
    id: "post-launch", file: "/press/lunelle-post-launch.jpg", format: "Instagram / TikTok post · 1:1",
    caption: "Your cycle has four seasons. Your life should move with them.\n\nLunelle is the cycle and lifestyle app that shapes your food, faith, style and money around every phase. Launching November 4.\n\nJoin the waitlist through the link in bio and become a founding member.",
  },
  {
    id: "post-pillars", file: "/press/lunelle-post-pillars.jpg", format: "Instagram post · 1:1",
    caption: "Your cycle at the centre. Your life around it.\n\nCycle. Nourish. Faith. Style. Money. Stars. Six daily rituals, one rhythm: yours.\n\nLunelle arrives November 4. Save your spot (link in bio).",
  },
  {
    id: "story-nov4", file: "/press/lunelle-story-nov4.jpg", format: "Instagram / TikTok story · 9:16",
    caption: "Nov 4. Mark it.\n\nLunelle: cycle and lifestyle, in one rhythm. Tap the link to join the waitlist.",
  },
  {
    id: "ig-seasons", file: "/press/lunelle-ig-post-seasons.jpg", format: "Instagram post · 1:1 · Week 1",
    caption: "Your cycle has four seasons: inner winter, spring, summer and autumn.\n\nEach one changes your energy, your cravings, your mood and even how you spend. Lunelle helps you move with them, not against them.\n\nWhich season are you in today? Tell us below.",
  },
  {
    id: "ig-faith", file: "/press/lunelle-ig-post-faith.jpg", format: "Instagram post · 1:1 · Week 1",
    caption: "Your faith belongs in your wellness routine.\n\nEvery morning, Lunelle gives you a word from your own tradition: Christian, Muslim, Jewish, Hindu, Buddhist or a spiritual affirmation. Your meals, fasting seasons and tips follow your customs too.\n\nSave this for a slow morning.",
  },
  {
    id: "ig-nourish", file: "/press/lunelle-ig-post-nourish.jpg", format: "Instagram post · 1:1 · Week 2",
    caption: "Eat for your phase and your body.\n\nIron-rich bowls in your inner winter, fresh and light in spring, colour and crunch at ovulation, slow comfort in autumn. Lunelle matches every plate to your body type and your faith: halal, kosher-friendly, vegetarian or plant-forward.\n\nSend this to the friend who always asks what's for dinner.",
  },
  {
    id: "ig-style", file: "/press/lunelle-ig-post-style.jpg", format: "Instagram post · 1:1 · Week 2",
    caption: "Dress for how you feel today.\n\nCosy knits when you need softness, bold colour when you're glowing. Lunelle gives you a colour of the day, an outfit, a hair idea and a beauty tip from your cycle, or from your sign if you follow the stars.\n\nWhat are you wearing today?",
  },
  {
    id: "ig-money", file: "/press/lunelle-ig-post-money.jpg", format: "Instagram post · 1:1 · Week 2",
    caption: "Ever noticed you spend more the week before your period? You're not imagining it.\n\nLunelle splits your budget across your four phases and warns you when the late-luteal spending urge usually hits.\n\nBudget with your cycle, not against it.",
  },
  {
    id: "ig-countdown", file: "/press/lunelle-ig-post-countdown.jpg", format: "Instagram post · 1:1 · Launch week (Oct 28)",
    caption: "7 days.\n\nOne week until Lunelle: your cycle, food, faith, style and money in one calm rhythm.\n\nJoin the waitlist through the link in bio to be a founding member.",
  },
  {
    id: "ig-story-3days", file: "/press/lunelle-ig-story-3days.jpg", format: "Instagram story · 9:16 · Nov 1",
    caption: "3 days to go.\n\nAdd a countdown sticker and a link sticker to the waitlist.",
  },
  {
    id: "ig-launch-day", file: "/press/lunelle-ig-post-launch-day.jpg", format: "Instagram post · 1:1 · Launch day (Nov 4)",
    caption: "Lunelle is here.\n\nTrack every phase of your cycle and let it shape what you eat, what you wear, how you spend and the word you start your day with, in your faith.\n\nFree to start. Download through the link in bio, and tag us in your first day.",
  },
  {
    id: "ig-story-live", file: "/press/lunelle-ig-story-live.jpg", format: "Instagram story · 9:16 · Launch day (Nov 4)",
    caption: "It's here.\n\nAdd a link sticker to the download page and repost every story you're tagged in today.",
  },
];

export const HASHTAGS = "#Lunelle #CycleSyncing #CycleTracking #WomensWellness #PeriodHealth #HormoneHealth #FaithAndWellness #CycleAwareLiving #SelfCareRituals #WellnessApp";

export const ASSETS = [
  ["Logo mark (SVG)", "/press/lunelle-logo-mark.svg"],
  ["App icon (PNG, 1024px)", "/press/lunelle-app-icon-1024.png"],
  ["Banner (JPG)", "/press/lunelle-banner.jpg"],
  ["Product photo (JPG)", "/press/lunelle-product-photo.jpg"],
];

export const BRAND_COLOURS = [["Terracotta", "#9E4429"], ["Clay", "#C86D51"], ["Blush", "#F4DED3"], ["Cream", "#FBF5EE"], ["Espresso", "#2C221E"], ["Sage", "#7E9379"]];

export const FACTS = [
  ["Launch date", "4 November 2026"],
  ["Platforms", "iOS and Android"],
  ["Category", "Cycle & lifestyle (health and wellness)"],
  ["Price", "Free to start"],
  ["Core features", "Cycle & symptom tracking, body-type nutrition, daily faith-based words, zodiac style, cycle-aware budgeting, pregnancy mode"],
  ["Press contact", "Lunellesee@gmail.com"],
];
